var map = {
	"./ar.json": [
		4214,
		214
	],
	"./en.json": [
		7429,
		385
	],
	"./hi.json": [
		773,
		773
	],
	"./ta.json": [
		6163,
		163
	],
	"./te.json": [
		7633,
		633
	],
	"./ur.json": [
		1453,
		453
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1131;
module.exports = webpackAsyncContext;